// import Upload from '@/components/Upload';
import { useMap } from '@/hooks/useMap';
import AMapLoader from '@amap/amap-jsapi-loader';
import { SearchOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { v4 } from 'uuid';

const MapContainer = ({
  baseData,
  mapKey,
  mapId,
  onLocationChange,
}: {
  baseData: { lat?: number; lon?: number; location?: string };
  mapKey: string;
  mapId: string;
  onLocationChange: (info: { lng?: number; lat?: number; detail?: string; lon?: number }) => void;
}) => {
  const mapRef = useRef(null);
  const placeSearchRef = useRef(null);
  const markerRef = useRef(null);
  const autoRef = useRef(null);
  const geocoderRef = useRef(null);
  const AMapRef = useRef(null);

  const getAddressInfo = (location: { lng: number; lat: number }, isInitial?: boolean) => {
    const { lng, lat } = location;
    // 确保 lat 和 lng 是数字类型
    const latNum = Number(lat);
    const lonNum = Number(lng);
    
    if (isNaN(latNum) || isNaN(lonNum)) {
      return;
    }
    
    // console.log(lng, lat);
    // @ts-ignore
    if (!isInitial) markerRef.current?.setPosition([lonNum, latNum]);
    // @ts-ignore
    mapRef.current?.setCenter(location);
    // 先更新坐标，即使地址解析失败也能看到坐标变化
    onLocationChange({ lat: latNum, lon: lonNum, detail: undefined });
    // @ts-ignore
    if (geocoderRef.current) {
      // @ts-ignore
      geocoderRef.current?.getAddress(location, (...args) => {
        // console.log({ args }, args[1].regeocode.formattedAddress);
        try {
          const addressDetail = args[1].regeocode.formattedAddress;
          // 更新地址信息，保持坐标不变
          onLocationChange({ lat: latNum, lon: lonNum, detail: addressDetail });
        } catch {
          // 地址解析失败，但坐标已更新
        }
      });
    }
  };

  const getInitialAddress = () => {
    if (baseData.lat && baseData.lon) {
      return [Number(baseData.lon), Number(baseData.lat)];
    }
    return [116.406315, 39.908775];
  };
  const initialMap = async () => {
    // console.log(baseData);
    const searchInputId = `${mapId}-search`;
    try {
      const AMap = await AMapLoader.load({
        key: mapKey, // 申请好的Web端开发者Key，首次调用 load 时必填
        version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      });
      AMapRef.current = AMap;
      mapRef.current = new AMap.Map(mapId, {
        viewMode: '2D', // 是否为3D地图模式
        zoom: 13, // 初始化地图级别
        center: getInitialAddress(),
        resizeEnable: true,
      });
      // geocoderRef.current = new AMap.Geocoder({});
      AMap.plugin(['AMap.AutoComplete', 'AMap.PlaceSearch', 'AMap.Geocoder'], function () {
        geocoderRef.current = new AMap.Geocoder({});
        autoRef.current = new AMap.AutoComplete({ input: searchInputId });
        // console.log(autoRef.current);
        placeSearchRef.current = new AMap.PlaceSearch({
          pageSize: 1, // 单页显示结果条数
          pageIndex: 1, // 页码
          // citylimit: true, // 是否强制限制在设置的城市内搜索
          panel: false,
          map: mapRef.current, // 展现结果的地图实例
          autoFitView: true, // 是否自动调整地图视野使绘制的 Marker 点都处于视口的可见范围
        });
        // @ts-ignore
        placeSearchRef.current.on('markerClick', ({ data }) => {
          // console.log({ args });
          getAddressInfo(data.location);
        });

        // @ts-ignore
        autoRef.current.on('select', function (e) {
          // console.log({ e });
          // 针对选中的poi实现自己的功能
          setSearchValue(e.poi.name);
          // @ts-ignore
          placeSearchRef.current.search(e.poi.name, (status, { poiList: { pois } }) => {
            // console.log(pois);
            try {
              const { location } = pois[0];
              // const { lat, lng } = location;
              getAddressInfo(location);
            } catch {}
          });
        });
        if (baseData.lat && baseData.lon) {
          getAddressInfo(new AMap.LngLat(baseData.lon, baseData.lat), true);
        }
      });
      markerRef.current = new AMap.Marker({
        position: getInitialAddress(),
        offset: new AMap.Pixel(1, 1),
        zIndex: 300,
      });
      // @ts-ignore
      markerRef.current?.setMap?.(mapRef.current);
      // @ts-ignore
      mapRef.current?.on('click', (e) => {
        // console.log({ e });
        const { lnglat } = e;
        // const { lat, lng } = lnglat;
        getAddressInfo(lnglat);
      });
      // @ts-ignore
    } catch {}
  };

  useEffect(() => {
    // 确保 DOM 元素存在后再初始化地图
    const timer = setTimeout(() => {
      if (document.getElementById(mapId)) {
        initialMap();
      }
    }, 100);
    // console.log({ baseData });
    return () => {
      clearTimeout(timer);
      // @ts-ignore
      mapRef.current?.destroy?.();
    };
  }, [mapId]);

  const [searchValue, setSearchValue] = useState<string>('');

  const searchInputId = `${mapId}-search`;
  
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div style={{ height: '400px', margin: '10px 0', width: '100%', position: 'relative' }}>
        <div id={mapId} style={{ height: '100%', width: '100%' }}></div>
        <div style={{ position: 'absolute', top: '10px', left: '10px', right: '10px', zIndex: 1000 }}>
          <Input
            placeholder="请输入地点搜索"
            id={searchInputId}
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            suffix={<SearchOutlined style={{ color: '#999', cursor: 'pointer' }} />}
            style={{ width: '100%' }}
          ></Input>
        </div>
      </div>
    </div>
  );
};

const ipRegex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

interface MapFormItemsProps {
  // isOnlyMap?: boolean;
  protocol?: string;
}

const MapFormItems = (props?: MapFormItemsProps) => {
  const { mapKey, isInitialled } = useMap();
  const [mapId] = useState(() => `map-container-${v4()}`);

  console.log('props', props?.protocol);

  return (
    <>
      <Form.Item name="lat" noStyle>
        <div></div>
      </Form.Item>
      <Form.Item name="lon" noStyle>
        <div></div>
      </Form.Item>
      <Form.Item 
        dependencies={['lat', 'lon']} 
        noStyle
        shouldUpdate={(prevValues, currentValues) => {
          return prevValues.lat !== currentValues.lat || prevValues.lon !== currentValues.lon;
        }}
      >
        {({ getFieldValue, setFieldsValue }) => {
          const lat = getFieldValue('lat');
          const lon = getFieldValue('lon');
          return (
            <>
              <Form.Item label="设备详细地址" name="location">
                <Input placeholder="请输入设备详细地址" allowClear></Input>
              </Form.Item>
              <Form.Item label="设备坐标" style={{ display: 'none' }}>
                <Input
                  placeholder="请选择设备坐标"
                  value={lat !== undefined && lat !== null && lon !== undefined && lon !== null ? `${lat},${lon}` : ''}
                  readOnly
                ></Input>
              </Form.Item>
              {!isInitialled || !mapKey ? (
                <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                  地图配置出错，请重新配置再试
                </div>
              ) : (
                <MapContainer
                  onLocationChange={(info) => {
                    if (info.lat !== undefined && info.lon !== undefined) {
                      setFieldsValue({ 
                        lat: info.lat, 
                        lon: info.lon, 
                        location: info.detail,
                      });
                    }
                  }}
                  baseData={{ lat, lon }}
                  mapKey={mapKey}
                  mapId={mapId}
                ></MapContainer>
              )}
              {/* {!props?.isOnlyMap && (props?.protocol === 'ModbusRTU' || props?.protocol === 'ModbusTCP') && (
                <>
                  {props?.protocol !== 'ModbusRTU' && (
                    <Row gutter={24}>
                      <Col span={12}>
                        <Form.Item
                          label="设备IP地址"
                          name="ip"
                          rules={[
                            { required: true, message: '请输入设备IP地址' },
                            {
                              pattern: ipRegex,
                              message: '请输入有效的IPv4地址，例如 192.168.1.1',
                            },
                          ]}
                        >
                          <Input placeholder="请输入设备IP地址" allowClear />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label="设备端口"
                          name="port"
                          rules={[
                            { required: true, message: '请输入设备端口' },

                            {
                              pattern: /^(6553[0-5]|655[0-2]\d|65[0-4]\d{2}|6[0-4]\d{3}|[1-5]?\d{1,4})$/,
                              message: '请输入有效端口号 (1-65535)',
                            },
                          ]}
                        >
                          <Input placeholder="请输入设备端口" allowClear />
                        </Form.Item>
                      </Col>
                    </Row>
                  )}
                  <Row gutter={24}>
                    <Col span={12}>
                      <Form.Item label="从设备ID" name="slaveId" rules={[{ required: true, message: '请输入从设备ID' }]}>
                        <Input placeholder="请输入从设备ID" style={{ width: '100%' }}></Input>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item label="采集时间" name="period" rules={[{ required: true, message: '请输入从设备采集时间' }]}>
                        <Input placeholder="请输入设备采集周期，单位秒" style={{ width: '100%' }}></Input>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item label="设备工厂" name="manufacturer">
                    <Input placeholder="请输入设备工厂" allowClear></Input>
                  </Form.Item>
                  <Form.Item label="设备型号" name="model">
                    <Input placeholder="请输入设备型号" allowClear></Input>
                  </Form.Item>
                </>
              )} */}
            </>
          );
        }}
      </Form.Item>
    </>
  );
};
export default MapFormItems;
